import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { getIconBrandPrefix } from '../../shared/icon-brand-prefix';

@Component({
  selector: 'app-pass-key-delete-failure',
  templateUrl: './pass-key-delete-failure.component.html',
  styleUrl: './pass-key-delete-failure.component.scss',
  standalone: false
})
export class PassKeyDeleteFailureComponent implements OnInit {

  onCloseLinkSubmit: () => void;
  iconPrefix: string;

  constructor(private readonly translate: TranslateService,
              private readonly cookieService: CookieService) { }

  ngOnInit(): void {
    this.iconPrefix = getIconBrandPrefix(this.cookieService.get('client'));
  }

  onCloseClick(){
    this.onCloseLinkSubmit();
  }

}
